import styled from 'styled-components';
import {
  Modal as SemanticModal,
  Grid as SemanticGrid,
} from 'semantic-ui-react';
import { Text as TextLayoutComponent, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  min-width: 800px;
  min-height: 400px;
`;

export const Text = styled(TextLayoutComponent.Bold)`
  padding-bottom: 10px;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 400px;
  padding-top: 20px;
  padding-left: 40px;
  border: 2px solid #777777;
`;

export const Loader = styled(LoaderLayoutComponent)`
`;

export const Grid = styled(SemanticGrid)`
  &&& {
    margin: 0px;
    padding: 0px 10px;
    text-align: center;
    width: 100%;
  }
`;

export const Row = styled(SemanticGrid.Row)`
`;

export const Column = styled(SemanticGrid.Column)`
  ${(props) => props.lastChild
    && `
      &&&&&& {
        display: flex;
        justify-content: flex-end;
      }
    `
  }
`;
